import {SurveySlug} from 'client/common/types';

import {useBoxType} from 'client/common/hooks/box';

import {SurveySettingsMode} from './types';

export function useSettingsMode(slug: SurveySlug): SurveySettingsMode {
    const boxType = useBoxType(slug);

    if (boxType === 'ux') {
        return 'ux';
    }

    if (boxType === 'createSegment') {
        return 'createSegment';
    }

    if (!boxType) {
        return 'full';
    }

    return 'simple';
}
